module.exports = __webpack_public_path__ + "img/3.4.f9c6789b.png";